import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;



const SummaryCard = ({ data, tournament }: any) => {
    const totalCost = data.reduce((sum: number, pkg: any) => sum + (Number(pkg.costo) || 0), 0);
    type TurnoWaitlist = {
        FECHA_I: string;
        HORA: string;
        ORDEN: number;
        EVENTO: string;
        TURNO: number;
        DIASEMANA_I: string;
    };
    const [turnosWaitlist, setTurnosWaitlist] = useState<TurnoWaitlist[]>([]);
    useEffect(() => {
        if (tournament?.clave && data[0]?.jugadorClave) {
            fetch(
                `${BACKEND_URL}/api/turnos/jug/waitlist/${tournament.clave}/${data[0]?.jugadorClave}`
            )
                .then(res => res.json())
                .then(data => {
                    if (data) {
                        setTurnosWaitlist(data);
                    }
                });
        }
    },);

    return (
        <div className="bg-white shadow rounded-lg p-1 w-full overflow-y-auto text-xs">
            <h2 className="text-sm font-bold mb-1 text-green-700">Checkout Summary</h2>
            <div className="mb-1">{tournament.nombre}</div>
            <div className="mb-1">
                {data[0]?.jugadorNombre || 'Unknown Player'} <b>TAT ID:</b> {data[0]?.jugadorTATID || 'N/A'}
            </div>
            <div className="mb-1 text-gray-700">
                <b className='text-green-700'>Packages Cost:</b> ${totalCost.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
            <hr className="my-1 border-gray-300" />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-1 print:grid-cols-3 print:gap-4 text-xs">
                {data.map((pkg: any, idx: number) => (
                    <div key={idx} className="mb-2 border-b md:border-b-0 md:border-r pb-4 md:pb-0 md:pr-4 last:border-b-0 last:md:border-r-0 last:md:pr-0">
                        <div className="mb-1"><b>Package:</b> {pkg.paqueteDescripcion}</div>
                        <div className="mb-1"><b>Division:</b> {pkg.divisionDescripcion}</div>
                        {pkg.items.length > 0 && (
                            <div className="mb-1"><b>Items:</b></div>
                        )}
                        <ul className="list-none ml-4 mb-2">
                            {pkg.items.map((item: any) => (
                                <li key={item.CVEITEM}>
                                    {item.cantidad} {item.item}
                                </li>
                            ))}
                        </ul>
                        <div className="mb-1"><b>Schedule:</b></div>
                        <ul className="list-none ml-2">
                            {pkg.eventos.map((ev: any) => (
                                <li key={ev.CVEEVENTO}>
                                    <span className="font-semibold">{ev.evento}:</span>
                                    <ul className="ml-2">
                                        {ev.turnosInfo
                                            .slice()
                                            .sort((a: any, b: any) => a.TURNO - b.TURNO)
                                            .map((turno: any, i: number) => (
                                                <li key={i}>
                                                    {turno.HORARIO_I} {(turno.waitlist === 1) ? '(Waitlist)' : ''}
                                                </li>
                                            ))}
                                    </ul>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            {turnosWaitlist.length > 0 && (
                <div>
                    <div className="text-xs"><b>Waitlist:</b></div>
                    <ul className="list-none ml-4 text-xs">
                        {turnosWaitlist
                            .slice()
                            .sort((a, b) => a.TURNO - b.TURNO)
                            .map((ev: any) => (
                                <li key={ev.ORDEN}>
                                    <b>Number {ev.ORDEN} </b> for {ev.EVENTO} - {ev.DIASEMANA_I} {ev.FECHA_I} {ev.HORA}
                                </li>
                            ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

const Success = () => {

    // Read from localStorage
     const successData = JSON.parse(localStorage.getItem('successData') || '{}');
    const data = successData.packages || [];
    const tournament = successData.tournament || {};
    const paymentType = successData.paymentType || 'unknown';
    const totalCost = successData.totalCost || 0;
    const jugadorEMAIL = localStorage.getItem('player_email') || 'no email';
    const noncard = paymentType !== 'Card';

    const navigate = useNavigate();
     useEffect(() => {
        const sendNotificationEmail = async () => {
            // CREATE A UNIQUE KEY FOR THIS REGISTRATION
            const emailSentKey = `email_sent_${tournament.clave}_${data[0]?.jugadorTATID}`;
            const emailAlreadySent = sessionStorage.getItem(emailSentKey);

            // CHECK IF EMAIL ALREADY SENT
            if (emailAlreadySent) {
                console.log('✅ Email already sent for this registration, skipping...');
                return;
            }

            try {
                console.log('🔍 Sending notification email...');

                await fetch(`${BACKEND_URL}/api/email-tournamentSignUp`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        data,
                        tournament,
                        paymentType,
                        totalCost
                    }),
                });

                console.log('✅ Admin notification email sent successfully');

                // WAIT 1 SECOND TO FOOL RESEND RATE LIMITS
                await new Promise(resolve => setTimeout(resolve, 1000));

                console.log('🔍 Sending user confirmation email...');

                // SEND USER CONFIRMATION EMAIL
                await fetch(`${BACKEND_URL}/api/email-userConfirmation`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        data,
                        tournament,
                        paymentType,
                        totalCost,
                        email: jugadorEMAIL // Use the player email from localStorage
                    }),
                });

                console.log('✅ User confirmation email sent successfully');

                // MARK AS SENT TO PREVENT DUPLICATES
                sessionStorage.setItem(emailSentKey, 'true');
                console.log('✅ Both emails sent successfully');
            } catch (error) {
                console.error('❌ Failed to send notification email:', error);
            }
        };

        if (data.length > 0 && tournament.nombre) {
            sendNotificationEmail();
        }
    }, []);
    return (
        <div className="text-xs fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 max-h-screen w-full overflow-y-auto print:static print:bg-white print:p-0 print:m-0 print:shadow-none print:max-h-none print:overflow-visible">
            <div className="bg-white rounded-lg shadow-lg p-2 text-center max-h-full overflow-y-auto print:shadow-none print:p-0 print:rounded-none print:text-left print:max-h-none print:overflow-visible">
                <img src="/logo.avif" alt="TAT Logo" className="mx-auto mb-1 w-34 h-34" />
                <h2 className="text-sm font-bold mb-1 text-green-700">Thank you for registering!</h2>

                <p className="mb-1">
                    {noncard === true ? (
                        <>Selected squads have been successfully saved. <b>{paymentType}</b> Payment will be processed by a tournament staff member.<br /></>
                    ) : (
                        <>Selected squads have been successfully saved and <b>{paymentType}</b> payment has been processed.<br /></>
                    )}
                </p>
				<p> Don't forget to <b>book your room</b> at the venue for a DISCOUNTED rate here: <a href="https://www.trueamateurtournaments.com/hotelbookings" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">https://www.trueamateurtournaments.com/hotelbookings</a></p>
                <div className="mb-1">
                    <SummaryCard data={data} tournament={tournament} />
                </div>
                <div className="flex justify-center gap-4 print:hidden">
                    <button
                        className="bg-blue-600 text-white px-4 py-2 rounded font-semibold hover:bg-blue-700 transition"
                        onClick={() => window.print()}
                    >
                        Print / Save
                    </button>
                    <button
                        className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition shadow-lg"
                        onClick={() => {
                            localStorage.removeItem('tat_summary_data');
                            localStorage.removeItem('tat_summary_tournament');
                            localStorage.removeItem('non-card');
							localStorage.removeItem('paymentType');
							localStorage.removeItem('player_email');
                            const emailSentKey = `email_sent_${tournament.clave}_${data[0]?.jugadorTATID}`;
                            sessionStorage.removeItem(emailSentKey);
                            
                            // Check if user is logged in
                            const loggedInPlayer = localStorage.getItem('loggedInPlayer');
                            if (loggedInPlayer) {
                                navigate('/dashboard');
                            } else {
                                navigate('/login');
                            }
                        }}
                    >
                        Return to Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Success;